import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from './views/main/main.component';
import {LogoutComponent} from './views/logout/logout.component';
import {RegisterComponent} from './views/register/register.component';
import {HomeComponent} from './views/home/home.component';
import {MyListComponent} from './views/my-list/my-list.component';
import {RegisterDetailComponent} from './views/register-detail/register-detail.component';
import {UserComponent} from './views/user/user.component';
import {AuthenticateComponent} from './views/authenticate/authenticate.component';
import {KambanComponent} from './views/kamban/kamban.component';
import {MyListDetailComponent} from './views/my-list-detail/my-list-detail.component';
import {ClicNewsComponent} from './views/clic-news/clic-news.component';
import {ClicNewsDetailComponent} from './views/clic-news-detail/clic-news-detail.component';
import {AreaComponent} from './views/area/area.component';
import {UnityComponent} from './views/unity/unity.component';
import {CommitteeComponent} from './views/committee/committee.component';
import {DashboardComponent} from './views/dashboard/dashboard.component';
import {ChallengeComponent} from './views/challenge/challenge.component';
import { StoreManagementComponent } from './views/store-management/store-management.component';
import { MyListKaizenComponent } from './views/my-list-kaizen/my-list-kaizen.component';
import { MyListDetailKaizenComponent } from './views/my-list-detail-kaizen/my-list-detail-kaizen.component';
import { FrameComponent } from './views/frame/frame.component';
import { PurchasesExchangesComponent } from './views/purchases-exchanges/purchases-exchanges.component';
import { MyListDetailChallengeComponent } from './views/my-list-detail-challenge/my-list-detail-challenge.component';
import { ActionsComponent } from './views/actions/actions.component';
import { FinancialComponent } from './views/financial/financial.component';
import { AwardComponent } from './views/award/award.component';
import { SustainabilityComponent } from './views/sustainability/sustainability.component';
import { ActionsTasksComponent } from './views/actions-tasks/actions-tasks.component';

const routes: Routes = [
    {
        path: 'authenticate', component: AuthenticateComponent
    },
    {
        path: 'logout', component: LogoutComponent
    },
    {
        path: '', component: MainComponent,
        children: [
            {path: 'register', component: RegisterComponent},
            {path: 'register/:id', component: RegisterComponent},
            {path: 'register-detail', component: RegisterDetailComponent},
            {path: 'my-list', component: MyListComponent},
            {path: 'my-list-kaizen', component: MyListKaizenComponent},
            {path: 'my-list-detail-kaizen/:id/:code', component: MyListDetailKaizenComponent},
            {path: 'my-list-detail/:id/:code', component: MyListDetailComponent},
            {path: 'my-list-detail-challenge/:id', component: MyListDetailChallengeComponent},
            {path: 'kanban', component: KambanComponent},
            {path: 'kanban/:id', component: KambanComponent},
            {path: 'actions', component: ActionsComponent},
            {path: 'actions/:id', component: ActionsComponent},
            {path: 'actions-tasks/:id', component: ActionsTasksComponent},
            {path: 'user', component: UserComponent},
            {path: 'clic-news', component: ClicNewsComponent},
            {path: 'store-management', component: StoreManagementComponent},
            {path: 'clic-news-detail/:id', component: ClicNewsDetailComponent},
            {path: 'challenge', component: ChallengeComponent},
            {path: 'area', component: AreaComponent},
            {path: 'purchases-exchanges', component: PurchasesExchangesComponent},
            {path: 'frame', component: FrameComponent},
            {path: 'unity', component: UnityComponent},
            {path: 'committee', component: CommitteeComponent},
            {path: 'dashboard', component: DashboardComponent},
            {path: 'award', component: AwardComponent},
            {path: 'financial', component: FinancialComponent},
            {path: 'sustainability', component: SustainabilityComponent},
            {path: ':id', component: HomeComponent},
            {path: '', component: HomeComponent}
        ],
        // canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        relativeLinkResolution: 'legacy',
        scrollOffset: [0, 0],
        scrollPositionRestoration: 'top'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
